module.exports = __webpack_public_path__ + "static/img/shuyuAI_QR_Code.963a280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuyuAI_QR_Code.png
// module id = SiCE
// module chunks = 0